import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import Select from "src/components/Select";
import CustomSlider from "src/components/Slider";

import useResolvers from "src/hooks/useResolvers";
import { languageConfig } from "src/screens/Questions/AddBulkQuestions";

const BulkQuestionForm = ({ questionData, setQuestionData }) => {
  const { t, i18n } = useTranslation();
  const {
    DifficultyScale,
    QuestionTypeResolver,
    QuestionBankResolver,
    SliderDifficultyLevels,
  } = useResolvers();

  return (
    <Grid container className="question-form">
      <Grid item xs={12}>
        <Box className="mb-20 custom-input-wrap bg-light">
          <Typography variant="subtitle2" component="h5">
            {t("questions.bulkQuestionForm.noOfQuestions")}{" "}
            <span className="text-red">*</span>
          </Typography>

          <TextField
            size="small"
            type="number"
            variant="outlined"
            inputProps={{ min: 1, max: 5 }}
            value={String(questionData.numberOfQuestions)}
            onChange={(e) => {
              const value = Number(e.target.value);
              if (value > 5) return;
              setQuestionData((prev) => ({
                ...prev,
                numberOfQuestions: value,
              }));
            }}
          />
        </Box>

        <Grid container spacing={3} className="mb-20">
          <Grid item xs={12} md={6}>
            <Box className="custom-input-wrap select-box">
              <Typography variant="subtitle2" component="h5">
                {t("questions.bulkQuestionForm.typeOfQuestions")}{" "}
                <span className="text-red">*</span>
              </Typography>

              <Select
                value={String(questionData?.questionType)}
                className="mt-10"
                options={Object.entries(QuestionTypeResolver)
                  .slice(0, 2) // Enabling MCQ and Descriptive question types only
                  .map(([value, label]) => ({ label, value }))}
                onChange={(e) =>
                  setQuestionData((prev) => ({
                    ...prev,
                    questionType: Number(e.target.value),
                  }))
                }
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box className="custom-input-wrap select-box">
              <Typography variant="subtitle2" component="h5">
                {t("questions.bulkQuestionForm.questionBank")}{" "}
                <span className="text-red">*</span>
              </Typography>

              <Select
                value={String(questionData?.questionCategory)}
                className="mt-10"
                options={Object.entries(QuestionBankResolver).map(
                  ([value, label]) => ({ label, value })
                )}
                onChange={(e) =>
                  setQuestionData((prev) => ({
                    ...prev,
                    questionCategory: Number(e.target.value),
                  }))
                }
              />
            </Box>
          </Grid>
        </Grid>

        {/* <Box className="mb-20 custom-input-wrap select-box">
          <Typography variant="subtitle2" component="h5">
            {t("questions.bulkQuestionForm.bloomsTaxonomy")}{" "}
            <span className="text-red">*</span>
          </Typography>

          <Select
            className="mt-10"
            value={questionData?.bloomsTaxonomy}
            options={[
              {
                label: t(
                  "questions.bulkQuestionForm.bloomsTaxonomyOptions.create"
                ),
                value: "create",
              },
              {
                label: t(
                  "questions.bulkQuestionForm.bloomsTaxonomyOptions.evaluate"
                ),
                value: "evaluate",
              },
              {
                label: t(
                  "questions.bulkQuestionForm.bloomsTaxonomyOptions.analyze"
                ),
                value: "analyze",
              },
              {
                label: t(
                  "questions.bulkQuestionForm.bloomsTaxonomyOptions.apply"
                ),
                value: "apply",
              },
              {
                label: t(
                  "questions.bulkQuestionForm.bloomsTaxonomyOptions.understand"
                ),
                value: "understand",
              },
              {
                label: t(
                  "questions.bulkQuestionForm.bloomsTaxonomyOptions.remember"
                ),
                value: "remember",
              },
            ]}
            onChange={(e) =>
              setQuestionData((prev) => ({
                ...prev,
                bloomsTaxonomy: e.target.value,
              }))
            }
          />
        </Box> */}

        {languageConfig[i18n?.language]?.showInstructionsInput ? (
          <Box
            my={1}
            sx={{ position: "relative" }}
            className="mb-20 custom-input-wrap bg-light"
          >
            <Typography variant="subtitle2" component="h5">
              {t("questions.bulkQuestionForm.instruction")}{" "}
            </Typography>
            <TextField
              multiline
              size="small"
              variant="outlined"
              value={questionData?.instructions}
              onChange={(e) =>
                setQuestionData((prev) => ({
                  ...prev,
                  instructions: e.target.value,
                }))
              }
              inputProps={{ maxLength: 500 }}
            />
            <Typography
              variant="caption"
              sx={{ top: 0, right: 0, position: "absolute" }}
            >
              {questionData?.instructions?.length ?? 0}
              /500
            </Typography>
          </Box>
        ) : null}

        <Grid item xs={12}>
          <CustomSlider
            {...{
              marks: SliderDifficultyLevels,
              value: Object.keys(DifficultyScale).find(
                (k) => DifficultyScale[k] === questionData?.questionDificulty
              ),
              onChange: (e) =>
                setQuestionData((prev) => ({
                  ...prev,
                  questionDificulty: DifficultyScale[e?.target?.value] ?? 1,
                })),
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BulkQuestionForm;
